import { combineReducers } from 'redux';

import { authentication } from './authentication.reducer';
import { client } from './client.reducer';
import { modal } from './modal.reducer';
import { gst } from './gst.reducer';
import { billing } from './billing.reducer';
import { service } from './service.reducer';
import { supplier } from './supplier.reducer';
import { tds } from './tds.reducer';

const rootReducer = combineReducers({
  authentication,
  client,
  modal,
  gst,
  billing,
  service,
  supplier,
  tds
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js